import { useMemo } from 'react';

import { useMegaMenuQuery, useServiceAppState } from '@kc-console/context';

import type { Menus } from '@kc-console/context';

interface UserMenuStateProps {
  domainName: string;
  menus: Menus[];
  userName: string;
}

/**
 * @description
 * - 도메인 및 사용자 정보를 콘솔 레이아웃에 맞게 재정의하여 제공하는 훅입니다.
 */
export const useRefinedUserMenuState = (): UserMenuStateProps => {
  const { data: categories = [] } = useMegaMenuQuery();
  const {
    state: { userName, domainName },
  } = useServiceAppState();

  const menus = useMemo(() => {
    const globalCategory = categories.find(c => c.keyword === 'global');
    const settingsMenu =
      globalCategory?.services?.find(svc => svc.keyword === 'settings')?.menus || [];
    return settingsMenu;
  }, [categories]);

  return {
    domainName,
    userName,
    menus,
  };
};
